import { render, staticRenderFns } from "./ClientLayout.vue?vue&type=template&id=1df52456&scoped=true"
import script from "./ClientLayout.vue?vue&type=script&lang=js"
export * from "./ClientLayout.vue?vue&type=script&lang=js"
import style0 from "./ClientLayout.vue?vue&type=style&index=0&id=1df52456&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1df52456",
  null
  
)

export default component.exports